export default __webpack_public_path__ + "static/demo-b99f6e708a8d01cfa857a90d42ffdcd2.svg";